/**
 * La barra della scala: quanti metri sono un tratto della tela.
 *
 * La tela e' una proiezione di Mercatore a zoom 18 (`projection.ts`): un
 * pixel del mondo vale `156543,03 · cos(lat) / 2^18` metri, e la tela ne
 * contiene `scale` per unita'. Da li' ai pixel dello schermo passa la
 * finestra. Il tratto si sceglie fra lunghezze «tonde» — 1, 2, 5 e i loro
 * multipli — cosi' che stia entro un quarto della tela e si legga senza
 * calcoli (GI-247).
 */
const EQUATOR_M_PER_PX_Z0 = 156543.03392
const WORLD_ZOOM = 18

/** Metri per pixel del mondo a zoom 18, a quella latitudine. */
export function metresPerWorldPx(latitude: number): number {
  return (EQUATOR_M_PER_PX_Z0 * Math.cos((latitude * Math.PI) / 180)) / 2 ** WORLD_ZOOM
}

export interface ScaleBar {
  metres: number
  /** Larghezza sullo schermo, in pixel. */
  px: number
  label: string
}

const ROUND = [1, 2, 5]

/**
 * Il tratto piu' lungo fra quelli tondi che sta in `maxPx` pixel.
 * `metresPerPx` e' quanti metri vale un pixel dello schermo adesso.
 */
export function scaleBar(metresPerPx: number, maxPx: number): ScaleBar | null {
  if (!(metresPerPx > 0) || !(maxPx > 0)) return null
  const maxMetres = metresPerPx * maxPx
  let best = 0
  for (let power = -2; power <= 6; power += 1) {
    for (const round of ROUND) {
      const metres = round * 10 ** power
      if (metres <= maxMetres && metres > best) best = metres
    }
  }
  if (best === 0) return null
  return { metres: best, px: best / metresPerPx, label: best >= 1000 ? `${best / 1000} km` : `${best} m` }
}
